import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import store from '../store';
import { getArchievedTendorsList } from '../actions/accountAction';
import { connect } from 'react-redux';
import { translate } from 'react-multi-lang';
import Validation from './hoc/Validation';

class ArchivalTenders extends Component {
  constructor(props) {
    super(props);
    store.dispatch(getArchievedTendorsList());
    this.state = {};
  }

  // archival
  render() {
    const { actionReducer, t } = this.props;

    return (
      <div className="tab-content">
        <div id="home" className="tab-pane active">
          <section className="login-form mt-0">
            <div className="container">
              <div className="row">
                <div className="col-md-12 p-0 mx-auto tab-content border-0 cover-shadow mb-3 mt-3">
                  <div className="panel-heading">
                    <div className="mb-0">Archival Tenders</div>
                  </div>
                  <div className="panel-body p-policy pt-0 p-3">
                    <div className="policypage hightset trikbox">
                      <p className="mtclass" aria-label="List of Tenders">
                        <img src="images/arrowtre.jpg" className="me-2" alt="" /> List of Tenders
                      </p>

                      {actionReducer.archivedVendors?.length ? (
                        <div>
                          {actionReducer.archivedVendors.map((ele, ind) => {
                            console.log(ele, "eleeleele")
                            return (
                              <div className="ticker-item" key={ind}>
                                <a
                                  className="date-clr d-block"
                                  href={ele?.link}
                                  rel="noopener noreferrer"
                                  target="_blank"
                                  aria-label={ele?.aria_label}
                                >
                                  <img src="/images/right-arrow.png" alt="Go" className="me-1" />
                                  {t('homeContent.read', { param: 'react' })} pdf
                                </a>
                                {ele.link2 && (
                                  <a
                                    className="date-clr"
                                    href={ele.link2}
                                    rel="noopener noreferrer"
                                    target="_blank"
                                  >
                                    <img src="/images/right-arrow.png" alt="Go" className="me-1" />
                                    {t('homeContent.publicNotice', { param: 'react' })}
                                  </a>
                                )}
                                {ele?.size && ele?.size != "Unknown" ? `(${ele?.size})` : ""}
                              </div>
                            )
                          })}
                        </div>
                      ) : (
                        <p className='hightclt'>No Archived Vendors available</p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    );
  }
}


const mapStateToProps = store => {
  return store;
};
export default connect(mapStateToProps)(translate(Validation(ArchivalTenders)));

